import NewWorld from "./NewWorld";
import DesignConcept from "./DesignConcept";
import Story from "./Story";
import Guideline from "./Guideline";
import DesignGuideline from "./DesignGuideline";

const prefix = "design";

const Design: React.FC = () => {
  return (
    <div className={prefix}>
      <NewWorld />
      <DesignConcept />
      <Story />
      <Guideline />
      <DesignGuideline />
    </div>
  );
}

export default Design;
